export default {
	page_template_template_my_account: () => { import('./my-account'); },
	myaccount_returnform: () => { import('./my-account-newreturn'); },
	page_template_template_order_checkout: () => { import('./checkout'); }
}